import { render, staticRenderFns } from "./SocialBanner.vue?vue&type=template&id=bb0d2500&scoped=true&"
import script from "./SocialBanner.vue?vue&type=script&lang=js&"
export * from "./SocialBanner.vue?vue&type=script&lang=js&"
import style0 from "./SocialBanner.vue?vue&type=style&index=0&id=bb0d2500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0d2500",
  null
  
)

export default component.exports